"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nullableStringToInt = void 0;
const nullableStringToInt = value => value ? Number.isNaN(Number(value)) ? null : Number(value) : undefined;
exports.nullableStringToInt = nullableStringToInt;
